import React, { useContext, useState } from "react";
import Logo from "../../Assets/logo.png";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../../Context/AppContext";
import toast, { Toaster } from "react-hot-toast";
import { PulseLoader } from "react-spinners";

const NewPassword = () => {
  const navigate = useNavigate();
  const { authLoading, changeNewPass } = useContext(AppContext);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!password || password.length < 6) {
      toast.error("Password must be at least 6 characters");
      setError(true);
      return;
    }
    if (password !== confirmPassword) {
      toast.error("Passwords do not match");
      setError(true);
      return;
    }
    const id = sessionStorage.getItem("id");
    if (!id || id.length === 0) {
      toast.error("Admin ID is required");
      return;
    }
    const payload = {
      id,
      password,
    };

    await changeNewPass(payload, {
      onSuccess: (res) => {
        toast.success("Password changed successfully!");
        sessionStorage.removeItem("id");
        navigate("/login");
      },
      onFailed: (err) => {
        const errMsg = err.message ?? "Something went wrong!";
        toast.error(errMsg);
      },
    });
  };

  return (
    <>
      <Toaster />
      <div className="newpass-container">
        <form className="newpass-form" onSubmit={handleSubmit}>
          <div className="logo-container">
            <img src={Logo} alt="Logo" className="logo-img" />
          </div>
          <h2 className="form-title">Create New Password</h2>
          <p className="form-subtitle">
            Enter a secure password you'll remember
          </p>

          <input
            type="text"
            className="newpass-input m-0"
            placeholder="New Password"
            value={password}
            onChange={(e) => {
              const noSpaces = e.target.value.replace(/\s/g, "");
              setPassword(noSpaces);
            }}
          />
          {password && password.length > 0 && password.length < 6 && (
            <span className="text-danger" style={{ fontSize: "13px" }}>
              Password is too short – minimum 6 characters required!
            </span>
          )}
          <br />
          <input
            type="password"
            className="newpass-input mt-4 mb-0"
            placeholder="Confirm Password"
            value={confirmPassword}
            onChange={(e) => {
              const noSpaces = e.target.value.replace(/\s/g, "");
              setConfirmPassword(noSpaces);
            }}
          />
          {error == true && confirmPassword && confirmPassword != password && (
            <span className="text-danger" style={{ fontSize: "13px" }}>
              Password does not match!
            </span>
          )}
          <button
            type="submit"
            className="newpass-btn mt-4"
            disabled={authLoading}
          >
            {authLoading ? (
              <PulseLoader color="#fff" size={10} />
            ) : (
              "Set Password"
            )}
          </button>
        </form>
      </div>
    </>
  );
};

export default NewPassword;
